/**
 * Currency
 */
export interface CountryCurrency {
  /**
   * Country name
   * @example United States
   * @example Canada
   */
  country: string;
  /**
   * Country code
   * @example US
   * @example CA
   */
  countryCode: string;
  /**
   * Currency name
   * @example US Dollar
   * @example Canadian Dollar
   */
  currency: string;
  /**
   * Currency code
   * @example USD
   * @example CAD
   */
  currencyCode: string;
}

/**
 * Collection of currencies
 */
export class CountryCurrencies {
  private readonly byCountry: Map<string, CountryCurrency>;

  constructor(currencies: CountryCurrency[]) {
    this.byCountry = new Map(
      currencies.map((currency) => [currency.countryCode, currency]),
    );
  }

  /**
   * All currencies
   */
  all() {
    return this.byCountry.values();
  }

  /**
   * Get currency by country code
   */
  getByCountry(countryCode: string): CountryCurrency | undefined {
    return this.byCountry.get(countryCode);
  }
}
